import React from "react";
import { MapSection } from "./MapSection";
import { useFooterVisible, useMainClass, useNavigationVariant, useTitle } from "../Layout/Mobility3/Main";
import { ActivityProvider } from "./contexts";

import classes from "./SocialCollaboration.module.scss";
import { VenueCalendarModal } from "Components/VenueCalendarModal";
import { useActivity } from "./hooks";
import useMediaBreakpointDown from "Hooks/useMediaBreakpointDown";
import { ActivitySection } from "./ActivitySection";

const SocialCollaboration: React.FC = () => {
   const isMobile = useMediaBreakpointDown("md");
   useTitle("Social Collaboration");
   useNavigationVariant(isMobile ? undefined : "minimized");
   useMainClass("portal-main-no-padding");
   useFooterVisible(false);   
   const {prebinOptions, modalContainer, closePrebin, reloadActivities} = useActivity();

   return (
      <div className={classes.layout}>
         {isMobile 
         ? <ActivitySection />
         : <MapSection />}         
         {!!prebinOptions && <VenueCalendarModal isOpen={true} venueId={prebinOptions.venueId} container={modalContainer} selectedDate={prebinOptions.selectedDate} toggle={closePrebin} refreshUpcomingReservationList={reloadActivities} /> }
      </div>
   );
};

export default () => (
   <ActivityProvider>
      <SocialCollaboration />
   </ActivityProvider>
);
